module.exports = __webpack_public_path__ + "static/media/ola.014b18bf.jpg";